module.exports = __webpack_public_path__ + "img/23-birthday.0aaca45e.jpg";